import { Currency } from './currency';

export class Token extends Currency {
  constructor(public address: string, decimals: number, symbol: string, name: string) {
    super(decimals, symbol, name);
  }
}
